<template>
  <div class="phoneLoginPage" :style="{height: scrollerHeight}">
    <Header></Header>
    <!-- banner -->
    <div class="loginBox">
      <div class="header">
        <img class="titlePic" height="28px" src="../../../assets/picture/product/findPass.png">
        <img class="headerPic" height="100%" src="../../../assets/picture/product/Group.png">
      </div>
      <div class="contain">
        <div class="inputBox">
          <span class="title">{{$t('productIndex.userName')}}</span>
          <input type="text" v-model="loginForm.username" :placeholder="$t('productIndex.userNameFindPlaceholder')" >
        </div>
        <div class="inputBox">
         <!--  <div class="block">
                <el-slider v-model="value3" :show-tooltip="false">按住左边滑块，滑动至右边确认</el-slider>
          </div> -->
           <div class="drag" ref="dragDiv">
            <div class="drag_bg"></div>
            <div class="drag_text">{{confirmWords}}</div>
            <div ref="moveDiv" @touchstart="mousedownFn($event)" :class="{'handler_ok_bg':confirmSuccess}" class="handler handler_bg" style="position: absolute;top: 0px;left: 0px;"></div>
          </div>
          <span class="title">{{$t('productIndex.bindEmail')}}</span>
          <input type="password"  v-model="loginForm.password" :placeholder="$t('productIndex.bindEmailPlaceholder')" >
        </div>
      </div>
      <div class="footer">
        <div class="loginNow">{{$t('productIndex.sendEmail')}}</div>
      </div>
    </div>
    <div class="footerBox phoneShow">
        <div class="container">
          <p>&copy;{{copyright}}</p>
          <p>(<a target="_blank" href="http://beian.miit.gov.cn/">{{icpNumber}}</a>）</p>
        </div>
    </div>
    <!-- footer -->
<!--     <Footer></Footer> -->
  </div>
</template>

<script>
import Header from '../../common/header';
// import Footer from '../../common/footer';
export default {
  data() {
    return {
      icpNumber:'',
      copyright:'',
      beginClientX:0,           /*距离屏幕左端距离*/
      mouseMoveStata:false,     /*触发拖动状态  判断*/
      maxwidth:'',               /*拖动最大宽度，依据滑块宽度算出来的*/
      confirmWords:'按住左边滑块验证',   /*滑块文字*/
      confirmSuccess:false,       /*验证成功判断*/
      value3:0,
      isShowSearch:false,
      scrollerHeight:'',
      loginForm: {
        username: "",
        password: ""
      },
      //表单验证规则对象
      loginFormRules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ]
      },
    };
  },
  components: { Header },
  mounted(){
    this.getConfig();
    this.scrollerHeight = (window.innerHeight-60) + 'px';
    this.maxwidth = this.$refs.dragDiv.clientWidth;
      document.getElementsByTagName('html')[0].addEventListener('touchmove',this.mouseMoveFn);
      document.getElementsByTagName('html')[0].addEventListener('touchend',this.moseUpFn);
  },
  methods: {
    mousedownFn:function (e) {
        if(!this.confirmSuccess){
            e.preventDefault && e.preventDefault();   //阻止文字选中等 浏览器默认事件
            this.mouseMoveStata = true;
            this.beginClientX = e.changedTouches[0].clientX;
        }
    },        //mousedoen 事件
    successFunction(){
        this.confirmSuccess = true
        this.confirmWords = '';
        if(window.addEventListener){
            document.getElementsByTagName('html')[0].removeEventListener('touchmove',this.mouseMoveFn);
            document.getElementsByTagName('html')[0].removeEventListener('touchend',this.moseUpFn);
        }else {
            document.getElementsByTagName('html')[0].removeEventListener('touchend',()=>{});
        }
        document.getElementsByClassName('drag_text')[0].style.color = '#900211'
        document.getElementsByClassName('handler')[0].style.left = this.maxwidth + 'px';
        document.getElementsByClassName('drag_bg')[0].style.width = this.maxwidth + 'px';
    },                //验证成功函数
    mouseMoveFn(e){
        if(this.mouseMoveStata){
            let width = e.changedTouches[0].clientX - this.beginClientX;
            if(width>0 && width<=this.maxwidth){
                document.getElementsByClassName('handler')[0].style.left = width + 'px';
                document.getElementsByClassName('drag_bg')[0].style.width = width + 'px';
            }else if(width>this.maxwidth){
                this.successFunction();
            }
        }
    },                   //mousemove事件
    moseUpFn(e){
        this.mouseMoveStata = false;
        var width = e.changedTouches[0].clientX - this.beginClientX;
        if(width<this.maxwidth){
            document.getElementsByClassName('handler')[0].style.left = 0 + 'px';
            document.getElementsByClassName('drag_bg')[0].style.width = 0 + 'px';
        }
    },
    showSearch(){
      this.isShowSearch = !this.isShowSearch;
    },
     //获取基础配置信息
    async getConfig() {
      const { data: res } = await this.$http.get("/config/getConfig.do");
      if (res.code !== 200) return this.$message.error(res.message);
      this.copyright = res.data.copyright;
      this.icpNumber = res.data.icpNumber;
    },
  }
};
</script>

<style lang="less" scoped>
.phoneLoginPage{
  width: 100%;
  height: 100%;
  background: #F0F2F5;  
  .drag{
        position: relative;
        background-color: #F2F2F2;
        border-radius: 100px;
        width: 56.6rem;
        height: 6rem;
        margin-left: 20px;
        line-height: 6rem;
        text-align: center;       
        font-size: 2.8rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #9A9A9A;
        margin-bottom: 10rem;
    }
    .handler{
        width: 6.8rem;
        height: 6.8rem;
        border-radius: 50%;
        background: #900211;
        cursor: move;
    }
    .handler_bg{
        margin-top: -2px;
        margin-left: -4rem;
        background-color: #900211;
    }
    .handler_ok_bg{
        margin-top: -2px;
        margin-left: -4rem;
        background-color: #900211;
        background-image:  url(../../../assets/picture/product/success.png);
        background-repeat:  no-repeat;
        background-size:  100% 100%;
        background-position:  center;
    }
    .drag_bg{
        background-color: #900211;
        height: 6rem;
        width: 0px;
        border-radius: 20rem
    }
    .drag_text{
        position: absolute;
        top: 0px;
        width: 100%;text-align: center;
        -moz-user-select: none;
        -webkit-user-select: none;
        user-select: none;
        -o-user-select:none;
        -ms-user-select:none;
    }  
  .loginBox{
    padding-top: 10rem;
    .header{
      width: 100%;
      height: 18.2rem;
      background: #353535;
      .titlePic{
        margin:6.5rem;
        height: 5rem;
      }
      .headerPic{
        float: right;
      }
    }
    .contain{
      background: #F0F2F5;
      padding:0 4rem;
      .inputBox{
        padding:11.2rem 0;
        border-bottom: 1px solid #D5D5D5;
        background: #F0F2F5;
        .block{
          margin-left: 4.8rem;
          margin-bottom: 10rem;
        }
         /deep/ .el-slider__runway{
            width: 90%;
            height: 30px;
            background: #F2F2F2;
            border-radius: 15px;
          }
          /deep/ .el-slider__bar{
            width: 284px;
            height: 30px;
            background: #900211;
            border-radius: 15px;
          }
          /deep/ .el-slider__button-wrapper .hover{
            border:1px solid #fff;
          }
          /deep/ .el-slider__button{
            width: 7rem;
            border: none;
            height: 7rem;
            background: #900211;
            border-radius: 100%;
            margin-left: -2px;
            margin-top: -2px;
          }
        .title{          
          font-size: 2.8rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #9A9A9A;
          line-height: 4rem;
          margin-right: 3.2rem;
        }
        input{
          border:none;        
          font-size: 2.8rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 4rem;
          outline:none;
          background: #F0F2F5;
        }
      }
    }
    .footer{
      background: #F0F2F5;
      padding: 10rem 0;
      .loginNow{
        width: 40.6rem;
        height: 8rem;
        background: #900211;    
        font-size: 2.8rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #F2F2F2;
        line-height: 8rem;
        letter-spacing: 2rem;
        text-align: center;
        margin:0 auto;
      }
    }
  }
}
.footerBox{
  width: 100%;
  background: #1E1E1E;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #F2F2F2;
  line-height: 20px;
  padding:20px 18px;
  position: fixed;
  bottom: 0;
  a,a:hover{
      font-weight: 500;
      color: #F2F2F2;
    }
}
</style>
